/* eslint-disable jsx-a11y/anchor-is-valid */
import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link, Route } from 'react-router-dom'

import { renderRoute, useQueryParams } from '../../../../util/utils'
import colors from '../../../../assets/colors'

import { useLocation } from 'react-router-dom'
import { fetchCashbackExtract } from '../CashbackExtractActions'
import { Filter } from './Filter'
import List from './List'
import ExtractDetails from './details'

const Extract = props => {
  const permissions = useSelector(state => state.auth.permissions)

  const location = useLocation()
  const dispatch = useDispatch()

  const filters = useQueryParams(location?.search)

  useEffect(() => {
    const finalFilters = {
      ...filters,
      grouped: true,
    }

    dispatch(
      fetchCashbackExtract(
        filters?.page || 1,
        finalFilters,
        filters?.rows || 10
      )
    )
  }, [location])

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography
          variant="h4"
          style={{ fontSize: '20px' }}
          color={colors.primary}
        >
          Extrato
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Filter />
      </Grid>

      <Grid item xs={12}>
        <List />
      </Grid>

      {renderRoute(['read-service-category-relatory'], permissions) && (
        <Link to="/cashback-module/extract/details/:id" />
      )}
    </Grid>
  )
}

export default Extract
